import styled from 'styled-components';

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  height: 32px;
  width: 32px;

  & > svg {
    object-fit: contain;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 10px;
  font-weight: 400;
`;
